import { useState, useEffect } from 'react';
import {
  AlertMessage,
  IconAlignment,
  IconStyle,
  Theme,
  useNextgenRouter,
  useTranslation,
} from '@nextgen-web-framework/all';
import { cmsApi } from '@commerce-webcomponents/sdk';
import { IppPlanCMSResponseType } from '@commerce-payment-webcomponents/sdk';
import InstalmentPlansProps from './types/propTypes';
import { InstalmentPlansDrawer } from './components/instalment-plans-drawer/InstalmentPlansDrawer';
import styles from './InstalmentPlans.module.scss';

export const InstalmentPlans = ({ ...props }: InstalmentPlansProps) => {
  const t = useTranslation();
  const router = useNextgenRouter();
  const [showPlansDrawer, setShowPlansDrawer] = useState(false);
  const [selectedPlanLabel, setSelectedPlanLabel] = useState('');
  const pifLabel = t('payment.instalmentPlanDrawer.PIF');

  useEffect(() => {
    if (props.selectedPlanId) {
      fetchContentStackPlans(`"${props.selectedPlanId?.toString()}"`);
    } else {
      setSelectedPlanLabel(pifLabel);
    }
  }, []);

  useEffect(() => {
    if (props.selectedPlanId) {
      fetchContentStackPlans(`"${props.selectedPlanId?.toString()}"`);
    } else {
      setSelectedPlanLabel(pifLabel);
    }
  }, [router?.params?.locale]);

  const fetchContentStackPlans = async (planIds: string | undefined) => {
    const cmsResponse = (await cmsApi.fetchContent({
      uId: 'instalment_payment_plan',
      params: [
        {
          key: 'query',
          value: `{"plan_id":{"$in":[${planIds}]}}`,
        },
      ],
    })) as IppPlanCMSResponseType;
    if (cmsResponse) {
      setSelectedPlanLabel(cmsResponse?.plan_title || '');
    }
  };

  const updateLabel = (label: string) => {
    setSelectedPlanLabel(label);
  };

  return (
    <>
      <AlertMessage
        className={styles['instalment-plan-link']}
        content={{
          detail: `${selectedPlanLabel}`,
          heading: t('payment.instalmentPlan.cta.label'),
        }}
        hasIcon
        onClick={() => setShowPlansDrawer(true)}
        theme={Theme.BLUE}
        icon="calendar-check"
        iconAlignment={IconAlignment.CENTER}
        iconStyle={IconStyle.SOLID}
      />
      {showPlansDrawer && (
        <InstalmentPlansDrawer
          {...props}
          onDrawerClose={() => setShowPlansDrawer(false)}
          enablePayInFull={true}
          updateLabel={updateLabel}
        />
      )}
    </>
  );
};
